import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    token: "",
    userInfo: null,
    platform: "web",
    menuActive: "home",
    config: {},
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo;
    },
    SET_PLATFORM(state, platform) {
      state.platform = platform;
    },
    CLEAR_AUTH_DATA(state) {
      state.token = "";
      state.userInfo = null;
    },
    INITIALIZE_STORE(state) {
      const token = sessionStorage.getItem("token");
      if (token) {
        state.token = token;
        state.userInfo = JSON.parse(sessionStorage.getItem("userInfo") || "null");
        state.platform = sessionStorage.getItem("platform") || "web";
      } else {
        // 如果没有 token，默认根据设备类型设置 platform
        const userAgent = navigator.userAgent.toLowerCase();
        state.platform = /mobile|android|iphone|ipad|phone/i.test(userAgent) ? "mobile" : "web";
      }
    },
    SET_MENU_ACTIVE(state, menuActive) {
      state.menuActive = menuActive;
    },
    SET_CONFIG(state, config) {
      state.config = config;
    },
  },
  actions: {
    login({ commit }, { token, userInfo }) {
      commit("SET_TOKEN", token);
      commit("SET_USER_INFO", userInfo);
    },
    logout({ commit }) {
      commit("CLEAR_AUTH_DATA");
    },
    initializeStore({ commit }) {
      commit("INITIALIZE_STORE");
    },
    setMenuActive({ commit }, menuActive) {
      commit("SET_MENU_ACTIVE", menuActive);
    },
    setConfig({ commit }, config) {
      commit("SET_CONFIG", config);
    },
    setPlatform({ commit }, platform) {
      commit("SET_PLATFORM", platform);
    },
    setUserInfo({ commit }, userInfo) {
      commit("SET_USER_INFO", userInfo);
    },
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      paths: ["token", "userInfo", "platform", "config", "menuActive"],
    }),
  ],
});

export default store;
